module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/village/levelIcon//4_wonderful.png?v=e201fdf7";